import type { IconProps } from './types';

export const H3Icon = (props: IconProps) => {
  const {
    size = 24,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M15.0745 18.3645C15.4405 18.2353 15.84 18.4066 16.0022 18.7503L16.0315 18.8216L16.1047 18.9866C16.3041 19.3566 16.6948 19.6067 17.1428 19.6067H18.429C19.0795 19.6065 19.6065 19.0795 19.6067 18.429V18.1067C19.6065 17.4562 19.0795 16.9292 18.429 16.929H17.7854C17.3715 16.9288 17.0356 16.5929 17.0354 16.179C17.0354 15.7906 17.3309 15.4712 17.7092 15.4329L17.7854 15.429H18.2678C18.83 15.429 19.2854 14.9726 19.2854 14.4104C19.2853 13.8837 18.8853 13.45 18.3723 13.3977L18.2678 13.3929H17.304C16.8391 13.3929 16.4444 13.7055 16.3235 14.1331C16.2106 14.5314 15.7961 14.7634 15.3977 14.6507C14.9994 14.5379 14.7678 14.1232 14.8801 13.7249C15.1789 12.6685 16.1503 11.8929 17.304 11.8929H18.2678L18.5256 11.9056C19.795 12.0346 20.7853 13.107 20.7854 14.4104C20.7854 15.0454 20.5483 15.6238 20.1604 16.0667C20.7386 16.5579 21.1066 17.2886 21.1067 18.1067V18.429C21.1065 19.908 19.9079 21.1065 18.429 21.1067H17.1428C16.0484 21.1067 15.1085 20.4513 14.6926 19.513L14.6165 19.3216L14.595 19.2473C14.5054 18.8781 14.7085 18.4939 15.0745 18.3645ZM10.6067 17.7854V11.4641H4.39282V17.7854C4.39282 18.1996 4.05704 18.5354 3.64282 18.5354C3.22861 18.5354 2.89282 18.1996 2.89282 17.7854V3.64286C2.89282 3.22864 3.22861 2.89286 3.64282 2.89286C4.05704 2.89286 4.39282 3.22864 4.39282 3.64286V9.96415H10.6067V3.64286C10.6067 3.22878 10.9427 2.89308 11.3567 2.89286C11.7709 2.89286 12.1067 3.22864 12.1067 3.64286V17.7854C12.1067 18.1996 11.7709 18.5354 11.3567 18.5354C10.9427 18.5352 10.6067 18.1995 10.6067 17.7854Z"
        fill={color}
      />
    </svg>
  );
};
